/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ChangeEvent } from 'react';
import {
  Button,
  ButtonAppearance,
  ButtonSize,
  SideSheetContentCol,
  Box,
  Text,
  SideSheetBody,
  Checkbox,
  SideSheetFooter,
} from '@bechtel/gds';
import { DrawerOuterStyled, DrawerBackdropStyled, DrawerHeader, DrawerClose, SubHeader } from './styled';
import { Form, Formik, Field } from 'formik';
import { CommodityTypeList } from './commodity-type-list';
import { Milestones } from './milestones-list';
import { MaterialStatus } from './material-status';
import { BacklogFilter } from '../types';
import { DrawerFooterButtonStyled, ErrorBoundary } from '@bechtel/client-common';
import { isEqual } from 'lodash';
import { defaultValues } from '../types';
import { Trans } from '@lingui/macro';

export interface BacklogSearchDrawerProps {
  close?: () => void;
  onBacklogFilterSubmit?: (value: any) => void;
  initialValues: BacklogFilter;
}

export const BacklogSearchDrawer: React.FC<BacklogSearchDrawerProps> = ({
  close,
  onBacklogFilterSubmit,
  initialValues,
}) => {
  return (
    <DrawerBackdropStyled data-testid="backlog-filter">
      <Formik
        initialValues={initialValues}
        onSubmit={(formData) => {
          onBacklogFilterSubmit && onBacklogFilterSubmit(formData);
          close && close();
        }}
      >
        {({ isValid, dirty, values, setFieldValue, setValues }) => {
          defaultValues.commodityTypesCount = values.commodityTypesCount;
          defaultValues.materialStatusCount = values.materialStatusCount;
          defaultValues.milestoneCount = values.milestoneCount;
          return (
            <Form>
              <DrawerOuterStyled>
                <DrawerHeader>
                  <DrawerClose onClick={close}></DrawerClose>
                </DrawerHeader>
                <SideSheetBody>
                  <ErrorBoundary>
                    <SideSheetContentCol>
                      <Field name="commodityTypes" component={CommodityTypeList} />
                      <Field name="milestones" component={Milestones} />
                      <Field name="materialStatus" component={MaterialStatus} />
                      <SubHeader>
                        <Box>
                          <Box mr={{ sm: '600' }}>
                            <Checkbox
                              name="expiredMilestoneFilter"
                              type="checkbox"
                              checked={values.expiredMilestoneFilter === true}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                e.target.checked
                                  ? setFieldValue('expiredMilestoneFilter', true)
                                  : setFieldValue('expiredMilestoneFilter', false)
                              }
                            />
                          </Box>
                          <Text color="grey.1000" size="400" weight="600">
                            <Trans>Expired Milestone</Trans>
                          </Text>
                        </Box>
                      </SubHeader>

                      <Box p={{ sm: '500' }}>
                        <Button
                          type="reset"
                          data-testid="reset-button"
                          size={ButtonSize.MEDIUM}
                          css={`
                            color: ${({ theme }) => theme.colors.blue[800]};
                            font-weight: ${({ theme }) => theme.fontWeights[600]};
                          `}
                          appearance={ButtonAppearance.SECONDARY}
                          disabled={isEqual(defaultValues, values)}
                          onClick={() => {
                            setValues(defaultValues);
                          }}
                        >
                          <Trans>Reset All Filters</Trans>
                        </Button>
                      </Box>
                    </SideSheetContentCol>
                  </ErrorBoundary>
                </SideSheetBody>
                <SideSheetFooter>
                  <Box justifyContent={{ sm: 'flex-end' }}>
                    <Box mr={{ sm: '400' }}>
                      <DrawerFooterButtonStyled
                        data-testid="cancel-button"
                        size={ButtonSize.MEDIUM}
                        appearance={ButtonAppearance.SECONDARY}
                        onClick={close}
                      >
                        <Trans>Cancel</Trans>
                      </DrawerFooterButtonStyled>
                    </Box>
                    <Box>
                      <DrawerFooterButtonStyled
                        data-testid="submit-button"
                        type="submit"
                        size={ButtonSize.MEDIUM}
                        appearance={ButtonAppearance.SECONDARY}
                        disabled={!dirty || !isValid}
                      >
                        <Trans>Done</Trans>
                      </DrawerFooterButtonStyled>
                    </Box>
                  </Box>
                </SideSheetFooter>
              </DrawerOuterStyled>
            </Form>
          );
        }}
      </Formik>
    </DrawerBackdropStyled>
  );
};
